import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LearnpageService } from '../services/learnpage.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-learn-page',
  templateUrl: './learn-page.component.html',
  styleUrls: ['./learn-page.component.scss']
})
export class LearnPageComponent {
    @ViewChild("myckeditor") ckeditor: any;
  
form: FormGroup;
serverErrors: any;
previewThumbnail: string;
learnItems: any[] = [];
Add = false;
Edit = false;
path: string;
ckeConfig:any;
constructor(
  private router: Router,
  private _fb: FormBuilder,
  private service: LearnpageService,
  private toastr: ToastrService
) {
  this.form = this._fb.group({
    _id: [''],
    modelName: [''],
    url: [''],
    title: [''],
    description: [''],
    status: ['active'],
    thumbnail: [''],
  });
}

  ngOnInit() {
    this.ckeConfig = {
      allowedContent: true,
      extraPlugins: 'divarea',
      forcePasteAsPlainText: true,
      removePlugins: 'exportpdf',
    };

  this.path = environment.userApiUrl;
  this.getData();
}

getData(): void {
  this.service.getData().subscribe({
    next: (res: any) => {
      this.learnItems = res.data || res;
    },
    error: () => {}
  });
}

submitForm() {
  const formData = new FormData();
  const formValue = this.form.value;
  Object.entries(formValue).forEach(([key, value]: any) => {
    formData.append(key, value);
  });
  this.service.add(formData).subscribe({
    next: (res: any) => {
      this.toastr.success(res.message || 'Created successfully');
      this.resetState();
    },
    error: (err: { status: number; error: { errors: {}; message: any; }; }) => {
      if ([400, 404].includes(err.status)) {
        this.serverErrors = err.error.errors || {};
      } else {
        this.toastr.error(err.error.message || 'Server error');
      }
    }
  });
}

updateForm() {
  const formData = new FormData();
  const formValue = this.form.value;
  Object.entries(formValue).forEach(([key, value]: any) => {
    formData.append(key, value);
  });
  this.service.update(formData).subscribe({
    next: (res: any) => {
      this.toastr.success(res.message || 'Updated successfully');
      this.resetState();
    },
    error: (err: { status: number; error: { errors: {}; message: any; }; }) => {
      if ([400, 404].includes(err.status)) {
        this.serverErrors = err.error.errors || {};
      } else {
        this.toastr.error(err.error.message || 'Server error');
      }
    }
  });
}

editItem(item: any) {
  this.Edit = true;
  this.Add = false;
  this.form.patchValue({
    _id: item._id || '',
    modelName: item.modelName || '',
    url: item.url || '',
    title: item.title || '',
    description: item.description || '',
    status: item.status || 'active',
    thumbnail: item.thumbnail || '',
  });
  this.previewThumbnail = item.image ? `${this.path}slider/${item.image}` : '';
}

deleteItem(id: string) {
  this.service.delete(id).subscribe({
    next: (res: any) => {
      this.toastr.success(res.message || 'Deleted successfully');
      this.getData();
    },
    error: (err: any) => {
      this.toastr.error(err.error.message || 'Delete failed');
    }
  });
}

onInputChange() {
  this.serverErrors = {};
}

uploadThumbnail(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    this.form.patchValue({ thumbnail: file });
    const reader = new FileReader();
    reader.onload = () => this.previewThumbnail = reader.result as string;
    reader.readAsDataURL(file);
  }
}

addItem() {
  this.Edit = false;
  this.Add = true;
  this.form.reset({ status: 'active' });
  this.previewThumbnail = '';
}

listItems() {
  this.Add = false;
  this.Edit = false;
}

resetState() {
  this.form.reset({ status: 'active' });
  this.listItems();
  this.getData();
  this.serverErrors = {};
}

}
